import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Login",
    meta: {
      transitionName: "fade",
      navBar: false,
    },
    component: () => import("../views/Login.vue"),
  },

  {
    path: "/payment-methods",
    name: "Métodos de pago",
    meta: {
      transitionName: "fade",
      navBar: true,
    },
    component: () => import("../views/PaymentMethods.vue"),
  },

  {
    path: "/tracking/:tab",
    name: "Tracking",
    meta: {
      transitionName: "fade",
      navBar: true,
    },
    component: () => import("../views/Tracking.vue"),
  },

  {
    path: "/menu",
    name: "Menu",
    meta: {
      transitionName: "fade",
      navBar: true,
    },
    component: () => import("../views/Menu.vue"),
  },

  {
    path: "/map",
    name: "Map",
    meta: {
      transitionName: "fade",
      navBar: true,
    },
    component: () => import("../views/errand/Map.vue"),
  },

  {
    path: "/payment-link",
    name: "Payment Link",
    meta: {
      transitionName: "fade",
      navBar: true,
    },
    component: () => import("../views/payment-links/Map.vue"),
  },

  {
    path: "/settings",
    name: "settings",
    meta: {
      transitionName: "fade",
      navBar: true,
    },
    component: () => import("../views/Settings.vue"),
  },

  {
    path: "/points",
    name: "Points",
    meta: {
      transitionName: "fade",
      navBar: true,
    },
    component: () => import("../views/points/points.vue"),
  },

  // {
  //   path: '/charts',
  //   name: 'charts',
  //   meta: {
  //     transitionName: 'fade',
  //     navBar: true
  //   },
  //   component: () => import('../views/Charts.vue')
  // },

  {
    path: "*",
    name: "not-found",
    meta: {
      transitionName: "fade",
      navBar: true,
    },
    component: () => import("../views/NotFound.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
